
//import config from './config.json'
import Menu from './components/Menu.vue'
import axios from 'axios'
export default {
  name: 'LayoutDefault',
  components: {
    Menu,
  },
  data () {
    return {
      leftDrawerOpen: false,
      lang : ""
    }
  },
  computed: {
    langBtn: function () {

      var btn;
      this.$store.state.language === "en" ? btn = "中文" : btn = "ENG";

      return btn;
    }
  },
  async created() {

    var config = await this.getConfig();
    localStorage.setItem("config", JSON.stringify(config) );

    var redirect_url = encodeURIComponent((process.env.VUE_APP_ENV === 'prod' ? config.prod_manulife_portal_url : (process.env.VUE_APP_ENV === 'uat' ? config.uat_manulife_portal_url : config.local_manulife_portal_url)))
    var locationStr = this.getBaseUrl(config) + '/spa/com/login/int_web.html#redirect_url=' + redirect_url + '&required2fa=0';
    console.log("START!");

    if ( this.$cookie.get('accessToken') == null ){

      console.log("NO JWT TOKENS")
      location.href = locationStr;

    } else {
      console.log("JWT TOKENS EXISTED");

      //var tokens = JSON.parse(this.$cookie.get('tokens').substring(2));
      var tokens = this.$cookie.get('accessToken');
      console.log(tokens);

      //localStorage.setItem('username', tokens.userName)

      console.log("getAuth(): verify start");
      await this.$http.get(config.verifyPath, {headers: {"Authorization": tokens}}
      ).then((res) => {

        console.log(res);

        if (res.data.verified && res.data.username === "manulife") {
          localStorage.setItem('username', tokens.userName)
          localStorage.setItem('lang', 'en')

          console.log("getAuth(): verified success")
        } else {
          console.log("getAuth(): verified fail")
          location.href = locationStr;
        }

      }, () => {
        console.log("getAuth(): verified fail")
        location.href = locationStr;
      });

    }
  },
  mounted() {

  },
  methods : {
    switchLang(){
      this.$store.state.language === "en" ? this.$store.state.language = "zh" : this.$store.state.language = "en";
      //console.log( this.$store.state.language );
       localStorage.setItem("lang", this.$store.state.language);
    },

    getBaseUrl: function(config) {
      return process.env.VUE_APP_ENV === 'prod' ? config.prod_BaseUrl : config.uat_BaseUrl;
    },

    async getConfig(){
      var config;
      if(process.env.VUE_APP_ENV === 'prod' || process.env.VUE_APP_ENV === 'uat'){
        config = "/manulife_portal/config/config.json";
      } else {
        config = "./config/config.json";
      }
      var result = await axios.get(config);
      return result.data;
    }
  }
}
